export enum WIDGET_SHARE {
    /**
     * @value Share on Facebook
     * @description Tooltip displayed on shareable content's social media icon
     */
    SHARE_FACEBOOK_BTN_TITLE = 'SOCIAL_ADVOCACY_FORM_SHARE_FACEBOOK_BTN_TITLE',
    /**
     * @value Share on LinkedIn
     */
    SHARE_MODAL_LINKEDIN = 'FRONT.SOCIAL_ADVOCACY.SHARE_MODAL.LINKEDIN',
    /**
     * @value Share on Twitter
     */
    SHARE_MODAL_TWITTER = 'FRONT.SOCIAL_ADVOCACY.SHARE_MODAL.TWITTER',
    /**
     * @value Share on
     */
    SHARE_ON = 'FRONT.SHARE_ON',
    /**
     * @value Share on email
     */
    SHARE_ON_EMAIL = 'WIDGET_SHARE.SHARE_ON_EMAIL',
    /**
     * @value Share on google currents
     */
    SHARE_ON_GOOGLE_CURRENTS = 'WIDGET_SHARE.SHARE_ON_GOOGLE_CURRENTS',
    /**
     * @value Share on viadeo
     */
    SHARE_ON_VIADEO = 'WIDGET_SHARE.SHARE_ON_VIADEO',
}
